import React from 'react';
import {ReactComponent as Logo} from '../../assets/img/vc-ops-logo-dark.svg';

const VcOpsLogo = ({ className = '', style = '', ...props  }) => {
  return (
    <Logo
      className={`w-100 ${className}`}
      style={style}
      {...props}
    />
  );
};

export default VcOpsLogo;
